import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import preferitiService from '../api/preferitiService';
import clienteAuthService from '../api/authService';
import { buildApiUrl } from '../../common/api';
import { usePageTutorial, TutorialButton } from '../../common/hooks/usePageTutorial';
import { areaRiservataSteps } from '../../common/tutorials/steps';

const baseUrl = import.meta.env.VITE_API_BASE_URL || '/backend';

function euro(v) {
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v || 0);
}

export default function Preferiti() {
  const [preferiti, setPreferiti] = useState([]);
  const [loading, setLoading] = useState(true);
  const { startTutorial } = usePageTutorial('cliente-preferiti', areaRiservataSteps);

  const load = async () => {
    if (!clienteAuthService.isAuthenticated()) return;
    setLoading(true);
    try {
      const res = await preferitiService.list();
      setPreferiti(res.data.preferiti || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const toggleNotifica = async (categoriaId) => {
    await preferitiService.toggleNotifica(categoriaId);
    load();
  };

  const remove = async (categoriaId) => {
    await preferitiService.remove(categoriaId);
    load();
  };

  if (!clienteAuthService.isAuthenticated()) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFEFA]">
        <Link to="/area-riservata/login" className="text-[#c78244] underline">Accedi per vedere i preferiti</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FFFEFA]">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="flex justify-between items-center mb-6">
          <Link to="/area-riservata" className="text-sm text-[#c78244] underline">← Area riservata</Link>
          <TutorialButton onStart={startTutorial} className="text-sm border rounded-lg px-3 py-1" />
        </div>
        <h1 className="text-2xl font-bold mb-6" data-tour="ar-preferiti">I tuoi preferiti</h1>
        {loading ? <p className="text-gray-400">Caricamento…</p>
          : preferiti.length === 0 ? <p className="text-gray-500">Nessun preferito. Aggiungili dal catalogo con il cuore.</p>
          : (
            <div className="grid sm:grid-cols-2 gap-4">
              {preferiti.map((p) => (
                <motion.div key={p.id} className="mang-card p-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                  {p.categoria?.foto?.[0] && (
                    <img src={`${baseUrl}/api/file/${p.categoria.foto[0].path}`} alt="" className="w-full h-32 object-cover rounded-lg mb-3" />
                  )}
                  <h3 className="font-semibold">{p.categoria?.nome}</h3>
                  <p className="text-[#c78244] font-bold">{euro(p.categoria?.prezzo_piatto)}</p>
                  <div className="flex gap-2 mt-3">
                    <Link to={`/catalogo/${p.categoria_catalogo_id}`} className="btn-sm bg-[#c78244] text-white px-3 py-1 rounded-lg text-sm">Ordina</Link>
                    <button type="button" onClick={() => toggleNotifica(p.categoria_catalogo_id)}
                      className={`text-sm px-2 py-1 rounded border ${p.notifica_nuovi ? 'border-green-500 text-green-700' : 'border-gray-300'}`}>
                      {p.notifica_nuovi ? '🔔 Notifiche on' : '🔕 Notifiche off'}
                    </button>
                    <button type="button" onClick={() => remove(p.categoria_catalogo_id)} className="text-sm text-red-600">Rimuovi</button>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
